
import React, { useState, useEffect, useCallback} from "react";
import { 
  Modal, 
  ModalBody, 
  Input, 
  FormFeedback,
  Form,
  InputGroup,
  InputGroupAddon
} from 'reactstrap';
import {toast} from 'react-toastify';
import * as Yup from 'yup';
import LoadingButton from './LoadingButton';
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import { useMutation } from "react-query";
import { sendReferral } from "../api/actions/auth";
import { fetcher } from "../api/client";
import ReactGA from 'react-ga4';

const ReferrerModal = ({
  className,
  isOpen,
  formik: { handleSubmit, handleChange, values, errors, touched, isSubmitting},
  onCancel,
  ...props
}) => {
    const { t } = useTranslation('common')
    
    if (!isOpen) {
      return null
    }
    
    const onSubmit = () => {
      ReactGA.event ({
        category: 'Botón para referir a un amigo',
        action: 'Clic en el botón de referir amigo en Starter'
      })
      handleSubmit();
    }
  

    return (
      <Modal isOpen={isOpen} toggle={onCancel} centered 
        className={clsx({ className: true })}
        size={'md'}
      > 
         <ModalBody className="text-center p-4">
            <h4 className="text-dark mb-4"
              dangerouslySetInnerHTML={{
                __html: t('referAFriendAndWin')
              }} 
            />
            <Form noValidate>
              <InputGroup>
                  <Input 
                    type="text" 
                    className="text-muted w-50 p-4 d-inline rounded-left"
                    name="email" 
                    placeholder={t('forms.email')}
                    onChange={handleChange}
                    value={values.email} 
                    invalid={errors.email && touched.email}
                  />
                  <InputGroupAddon addonType="append">
                      <LoadingButton 
                        className="rounded-right"
                        loading={isSubmitting} 
                        onClick={onSubmit}
                        loadingText={t('actions.sending')} 
                        type="submit" 
                        color="accent" 
                        spinnerProps={{
                          color: 'accent'
                        }}
                        size="md"
                      > {t('actions.refer')}
                      </LoadingButton>
                  </InputGroupAddon> 
                  <FormFeedback className="text-left">{t(`errors.${errors.email}`)}</FormFeedback>
              </InputGroup>
            </Form>
          </ModalBody>
      </Modal>
    );
  }

const ReferrerSchema = Yup.object().shape({
    email: Yup.string()
      .email('InvalidEmail')
      .required('Required'),
});

function ReferrerModalContainer({isOpen = false, onClose}) {
  const { t } = useTranslation('common');

  const { mutate: mutateSendReferral } = useMutation((payload) => fetcher(sendReferral(payload)), {
    onSuccess: (data) => {
      console.log({data})
      if (data) {
        onClose()
        toast.info(t('successMessages.sentReferral'), {
          autoClose: 3000,
        })
      }
      
    }, 
    onError: (error) => {
      console.log({error})
      toast.error(t(`errorMessages.${error.message}`, t('errorMessages.generalError')),  {
        autoClose: 3000
      })
    }
  });
 
  const formik = useFormik({
    initialValues: {
      email: '',
    },
    onSubmit: async (values, actions) => {
      const referral = { 
        email: values.email,
        type: 'contracts'
      }

      await mutateSendReferral(referral, {
        onSuccess: () => {
          actions.resetForm()
        }
      });

      actions.setSubmitting(false)
    },
    validationSchema: ReferrerSchema,
    enableReinitialize: true
  })

 
  return <ReferrerModal isOpen={isOpen} formik={formik} onCancel={onClose} />
}
  
  export default ReferrerModalContainer;